class WindowService {
    geolocate() {
        return new Promise((resolve, reject) => {
            if (!window.navigator) {
                console.error('Geolocation is not supported');
                reject(new Error('Geolocation is not supported'));
            }
            else {
                window.navigator.geolocation.getCurrentPosition((position) => {
                    resolve(position);
                },
                (error) => {
                    console.error(error);
                    reject(error);
                });
            }
        });
    }

    getUrl() {
        return window.location.href;
    }
}

export default new WindowService();
